import { useState, useEffect } from "react";

const DOOR_TYPES = [
  { value: "swing", label: "Swing door", hint: "Normal hinged door" },
  { value: "sliding", label: "Sliding door", hint: "Slides sideways" },
  { value: "open", label: "Open passage", hint: "No door — walk-through" },
];

function DoorEditor({ door, onUpdate, onDelete, onDeselect }) {
  const [width, setWidth] = useState(String(door.width));
  const [angle, setAngle] = useState(String(door.angle || 0));

  useEffect(() => {
    setWidth(String(door.width));
    setAngle(String(door.angle || 0));
  }, [door.id, door.width, door.angle]);

  const handleWidthBlur = () => {
    const v = parseFloat(width);
    if (!isNaN(v) && v > 0) onUpdate({ width: Math.round(v * 10) / 10 });
    else setWidth(String(door.width));
  };

  const handleAngleBlur = () => {
    let v = parseFloat(angle);
    if (isNaN(v)) {
      setAngle(String(door.angle || 0));
      return;
    }
    v = ((v % 360) + 360) % 360;
    onUpdate({ angle: v });
    setAngle(String(v));
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") e.target.blur();
  };

  const rotate = (delta) => {
    const v = ((((door.angle || 0) + delta) % 360) + 360) % 360;
    onUpdate({ angle: v });
  };

  return (
    <div className="room-editor">
      <div className="room-editor-header">
        <h3>Door Editor</h3>
        <button className="btn-icon" onClick={onDeselect} title="Deselect">
          ✕
        </button>
      </div>

      <div className="room-editor-field">
        <label>Type</label>
        <div className="door-type-group">
          {DOOR_TYPES.map((t) => (
            <button
              key={t.value}
              className={`door-type-btn ${door.type === t.value ? "active" : ""}`}
              onClick={() => onUpdate({ type: t.value })}
              title={t.hint}
            >
              {t.label}
            </button>
          ))}
        </div>
      </div>

      <div className="room-editor-dimensions">
        <div className="dim-field">
          <label>Width (m)</label>
          <input
            type="number"
            step="0.1"
            min="0.3"
            value={width}
            onChange={(e) => setWidth(e.target.value)}
            onBlur={handleWidthBlur}
            onKeyDown={handleKeyDown}
          />
        </div>
        <div className="dim-field">
          <label>Angle (°)</label>
          <input
            type="number"
            step="15"
            value={angle}
            onChange={(e) => setAngle(e.target.value)}
            onBlur={handleAngleBlur}
            onKeyDown={handleKeyDown}
          />
        </div>
      </div>

      <div className="door-rotate-row">
        <button className="btn-secondary" onClick={() => rotate(-90)} title="Rotate 90° left">
          ↺ 90°
        </button>
        <button className="btn-secondary" onClick={() => rotate(90)} title="Rotate 90° right">
          ↻ 90°
        </button>
      </div>

      <p className="editor-hint">Drag the door on the map to position it on a wall.</p>

      <div className="room-editor-actions">
        <button className="btn-secondary btn-danger" onClick={onDelete}>
          Delete Door
        </button>
      </div>
    </div>
  );
}

export default DoorEditor;
